import { frontendURL } from '../../../../helper/URLHelper';
import { FEATURE_FLAGS } from '../../../../featureFlags';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';
import AgentPage from './AgentPage.vue';

// PA-01 (D17): quem decide o acesso agora é o backend, por faixa: super-admin entra
// sempre; administrador da conta entra quando `power_agents` estiver ligada naquela conta.
// Repetido nas duas rotas de propósito — a tela do agente não é mais filha do wrapper e
// portanto não herda mais nada pelo `to.matched`.
// `agent` entra em 22/09/2026 pela faixa de LEITURA. Quem decide o que ele alcança é o
// backend (`PowerAgentsGuard::ACOES_DE_LEITURA`); a rota só deixa de barrá-lo na porta,
// senão a faixa existiria no servidor e ninguém conseguiria chegar nela.
//
// ACESSO-01 (L8b): com a chave ACESSO_GRANULAR ligada, a lista e a tela do agente pedem o `poweragents:read`
// (`power_agents#index`, `#show`), e o que cada um faz lá dentro é o escopo de cada ação. A flag continua por cima.
const ESCOPOS = ['poweragents:read'];

const PERMISSOES = {
  superAdminOrFlag: FEATURE_FLAGS.POWER_AGENTS,
  featureFlag: FEATURE_FLAGS.POWER_AGENTS,
  permissions: ['administrator', 'agent', 'poweragents_manage'],
  escopos: ESCOPOS,
};

export default {
  // A LISTA de agentes vive dentro do shell do OS: é uma tela de configuração como as
  // outras, com a barra lateral ao lado.
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/power-agents'),
      meta: { ...PERMISSOES },
      component: SettingsWrapper,
      props: {
        // A lista rola por dentro (`h-full overflow-y-auto` na raiz dela) e quer a altura,
        // não o scroll do wrapper.
        fullHeight: true,
      },
      children: [
        {
          path: '',
          name: 'power_agents_index',
          component: Index,
          meta: {
            permissions: ['administrator', 'poweragents_manage'],
            escopos: ESCOPOS,
          },
        },
      ],
    },
  ],
  // Entrar num agente é entrar num ambiente próprio: ele tem menu de seis seções e o menu
  // do OS ao lado não leva a lugar nenhum daqui. Igual a um PowerApp, ocupa a viewport
  // inteira — fora do AppContainer, e não apenas com a barra lateral escondida, o que
  // deixava duas faixas de cabeçalho empilhadas. A volta é o "Back to agents" do
  // cabeçalho da própria tela.
  //
  // A URL é a mesma de antes: só o lugar do registro na árvore mudou, para não quebrar
  // link salvo nem o título derivado do path no MonitorTopbar.
  standaloneRoutes: [
    {
      path: frontendURL('accounts/:accountId/settings/power-agents/:agentId'),
      name: 'power_agents_settings',
      component: AgentPage,
      meta: { ...PERMISSOES },
    },
  ],
};
